









import { Component, Vue, Prop } from 'vue-property-decorator';
import { colors } from '@/config';

@Component
export default class PGroup extends Vue {
    @Prop() icon: string | undefined;
    @Prop() iconColor: string | undefined;

    get defaultColor() {
        return 'black';
    }
}
